import { Button } from "@mui/material";

const ButtonOnTable = ({ variant = 'contained', size = 'small', bgColor = 'var(--main-softblue-color)', text, sx = {}, ...props }) => {
    return (
        <Button
            variant={variant}
            size={size}
            disableElevation
            disableRipple
            sx={{
                boxShadow: 'none',
                padding: '5px 14px',
                borderRadius: '20px',
                backgroundColor: bgColor,
                fontSize: '13px',
                color: '#fff',
                minWidth: '60px',
                '&:hover': { backgroundColor: bgColor, boxShadow: 'none' },
                ...sx
            }}
            {...props}
        >
            {text}
        </Button>
    );
};

export default ButtonOnTable;